import React from "react";

// Reusable typography blocks for legal documents
const H2 = ({ children }) => <h2 className="text-lg font-extrabold text-slate-900 mt-7 mb-2">{children}</h2>;
const P = ({ children }) => <p className="text-[15px] leading-relaxed text-slate-600 mb-3">{children}</p>;
const UL = ({ children }) => <ul className="list-disc pl-5 space-y-1.5 text-[15px] leading-relaxed text-slate-600 mb-3">{children}</ul>;
const B = ({ children }) => <b className="font-bold text-slate-800">{children}</b>;

export const LEGAL_DOCS = {
  termini: {
    slug: "termini",
    title: "Termini e Condizioni del Servizio",
    updated: "Ottobre 2026",
    body: (
      <>
        <P>
          Il presente sito web (di seguito, la "Piattaforma") è gestito da <B>EAT ME S.r.l.</B>, con sede legale in
          Via Palmiro Togliatti 21/2, 61122 Pesaro (PU), P.IVA/C.F. 02548710413, PEC: eatme@legalmail.it
          (di seguito, "EAT ME" o la "Società").
        </P>

        <H2>1. Oggetto del Servizio</H2>
        <P>
          La Piattaforma eroga un servizio tecnologico gratuito di bacheca e intermediazione digitale finalizzato a
          consentire la condivisione e lo scambio di coupon, buoni sconto e codici promozionali (di seguito, "Coupon")
          tra utenti consumatori ("Utenti") ed esercenti/venditori ("Venditori").
        </P>

        <H2>2. Ruolo di EAT ME S.r.l. e Limitazione di Responsabilità</H2>
        <P>
          2.1. EAT ME agisce esclusivamente in qualità di fornitore dell'infrastruttura tecnologica e non è in alcun
          modo parte dei rapporti commerciali, contrattuali o negoziali che si instaurano tra gli Utenti e i Venditori.
        </P>
        <P>
          2.2. EAT ME non effettua alcun controllo preventivo, né garantisce la veridicità, la validità, la fruibilità,
          la data di scadenza o l'effettiva applicabilità dei Coupon pubblicati o scambiati sulla Piattaforma.
        </P>
        <P>2.3. La Società non è in alcun modo responsabile per:</P>
        <UL>
          <li>Il mancato riconoscimento o rifiuto di un Coupon da parte di un Venditore o di terzi;</li>
          <li>Errori, inesattezze o omissioni presenti nei Coupon o nelle offerte collegate;</li>
          <li>La qualità, la sicurezza, la conformità o la legalità dei beni o servizi acquistati tramite i Coupon;</li>
          <li>Eventuali danni diretti, indiretti, punitivi o consequenziali derivanti dall'utilizzo o dall'impossibilità di utilizzare la Piattaforma o i Coupon.</li>
        </UL>

        <H2>3. Obblighi e Condotta dell'Utente</H2>
        <P>3.1. L'Utente si impegna a utilizzare la Piattaforma in conformità alle leggi vigenti, alla morale e al buon costume.</P>
        <P>3.2. È severamente vietato:</P>
        <UL>
          <li>Caricare Coupon falsi, contraffatti, già utilizzati o privi dei diritti di utilizzo;</li>
          <li>Utilizzare sistemi automatici (bot, scraper, spider) per accedere alla Piattaforma o estrarne dati;</li>
          <li>Utilizzare la Piattaforma per finalità illecite, ingannevoli o fraudolente.</li>
        </UL>
        <P>
          3.3. EAT ME si riserva il diritto insindacabile di sospendere o cancellare l'account di qualsiasi Utente o
          Venditore, e di rimuovere contenuti o Coupon, in caso di violazione delle presenti Condizioni o su segnalazione
          delle autorità competenti, senza alcun preavviso o indennizzo.
        </P>

        <H2>4. Modifica e Interruzione del Servizio</H2>
        <P>
          EAT ME offre la Piattaforma a titolo gratuito e si riserva il diritto di modificare, sospendere, interrompere o
          limitare le funzionalità della Piattaforma in qualsiasi momento, in tutto o in parte, senza preavviso e senza
          alcuna responsabilità nei confronti degli utenti.
        </P>

        <H2>5. Proprietà Intellettuale</H2>
        <P>
          Tutti i contenuti della Piattaforma (marchi, loghi, grafica, codice sorgente, layout) sono di proprietà
          esclusiva di EAT ME S.r.l. o dei rispettivi titolari dei diritti (es. marchi dei Venditori) e sono protetti
          dalle leggi sulla proprietà intellettuale.
        </P>

        <H2>6. Legge Applicabile e Foro Competente</H2>
        <P>
          Le presenti Condizioni sono regolate dalla legge italiana. Per qualsiasi controversia inerente alla validità,
          interpretazione o esecuzione del presente contratto, sarà competente in via esclusiva il Foro di Pesaro, fatti
          salvi eventuali diritti inderogabili previsti dalla legge a tutela dei consumatori.
        </P>
      </>
    ),
  },

  privacy: {
    slug: "privacy",
    title: "Informativa sulla Privacy (Privacy Policy)",
    updated: "Ottobre 2026",
    subtitle: "Ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR)",
    body: (
      <>
        <H2>1. Titolare del Trattamento</H2>
        <P>
          Il Titolare del trattamento dei dati personali è <B>EAT ME S.r.l.</B>, P.IVA 02548710413, con sede legale in
          Via Palmiro Togliatti 21/2, 61122 Pesaro (PU).<br />
          Email di contatto Privacy e PEC: <B>eatme@legalmail.it</B>
        </P>

        <H2>2. Tipologia di Dati Raccolti</H2>
        <P>Attraverso l'utilizzo della Piattaforma, il Titolare raccoglie le seguenti categorie di dati:</P>
        <UL>
          <li><B>Dati forniti volontariamente:</B> Nome, cognome, indirizzo email, credenziali di registrazione, dati di contatto inseriti dagli Utenti e dai Venditori al momento della creazione dell'account o della pubblicazione/richiesta di un Coupon.</li>
          <li><B>Dati di navigazione e tecnici:</B> Indirizzo IP, dati di log, tipo di browser, orari di accesso e identificativi del dispositivo utili a garantire la sicurezza e il corretto funzionamento del sito.</li>
        </UL>

        <H2>3. Finalità del Trattamento e Basi Giuridiche</H2>
        <P>I dati personali sono trattati per le seguenti finalità:</P>
        <UL>
          <li><B>Erogazione del servizio:</B> Consentire la registrazione, la gestione dell'account e l'interazione per lo scambio dei Coupon. (Base giuridica: Esecuzione del contratto o di misure precontrattuali - art. 6.1.b GDPR).</li>
          <li><B>Adempimento di obblighi di legge:</B> Ottemperare a obblighi fiscali, contabili o richieste delle autorità competenti. (Base giuridica: Obbligo di legge - art. 6.1.c GDPR).</li>
          <li><B>Sicurezza e prevenzione frodi:</B> Monitorare la corretta fruizione della Piattaforma e prevenire abusi o attività illecite. (Base giuridica: Legittimo interesse del Titolare - art. 6.1.f GDPR).</li>
        </UL>

        <H2>4. Modalità di Trattamento e Conservazione</H2>
        <P>
          Il trattamento viene effettuato con strumenti elettronici e automatizzati adottando adeguate misure di
          sicurezza tecniche e organizzative. I dati saranno conservati per tutta la durata dell'account dell'utente e,
          successivamente, per il tempo strettamente necessario all'adempimento degli obblighi di legge o alla difesa dei
          diritti del Titolare in sede giudiziaria.
        </P>

        <H2>5. Comunicazione e Destinatari dei Dati</H2>
        <P>I dati non saranno diffusi indiscriminatamente. Potranno essere comunicati a:</P>
        <UL>
          <li>Fornitori di servizi tecnici e di hosting che agiscono in qualità di Responsabili del Trattamento;</li>
          <li>Venditori o Utenti partner nella misura strettamente necessaria all'erogazione o al riscatto del Coupon;</li>
          <li>Autorità giudiziarie o amministrative ove richiesto dalla legge.</li>
        </UL>

        <H2>6. Diritti dell'Interessato</H2>
        <P>Gli utenti hanno il diritto in qualsiasi momento di:</P>
        <UL>
          <li>Chiedere l'accesso ai propri dati personali, la rettifica o la cancellazione degli stessi;</li>
          <li>Richiedere la limitazione del trattamento o opporsi allo stesso;</li>
          <li>Richiedere la portabilità dei dati;</li>
          <li>Revocare il consenso in qualsiasi momento (ove prestato);</li>
          <li>Proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).</li>
        </UL>
        <P>
          Per esercitare tali diritti, l'utente può inviare una comunicazione scritta al Titolare all'indirizzo PEC
          <B> eatme@legalmail.it</B>.
        </P>
      </>
    ),
  },

  cookie: {
    slug: "cookie",
    title: "Cookie Policy",
    updated: "Ottobre 2026",
    subtitle: "Bozza da sottoporre a revisione legale prima della pubblicazione definitiva",
    body: (
      <>
        <H2>1. Cosa sono i cookie e le tecnologie simili</H2>
        <P>
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono
          memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. La Piattaforma utilizza cookie e
          tecnologie di memorizzazione locale del browser (es. <B>localStorage</B>) per il proprio funzionamento.
        </P>

        <H2>2. Cookie tecnici e di sessione (necessari)</H2>
        <P>
          La Piattaforma utilizza esclusivamente cookie e tecnologie tecniche strettamente necessari a garantire il
          corretto funzionamento del servizio, tra cui:
        </P>
        <UL>
          <li><B>Cookie/archiviazione di autenticazione:</B> mantengono l'utente connesso al proprio account (token di sessione) dopo l'accesso.</li>
          <li><B>Cookie di preferenza:</B> memorizzano impostazioni come la posizione selezionata, lo stato del tutorial o le preferenze di visualizzazione.</li>
          <li><B>Cookie di sicurezza:</B> aiutano a prevenire abusi e a proteggere l'account dell'utente.</li>
        </UL>
        <P>
          Questi strumenti non richiedono il consenso preventivo dell'utente in quanto indispensabili all'erogazione del
          servizio espressamente richiesto (art. 122 D.Lgs. 196/2003 e Linee guida del Garante Privacy).
        </P>

        <H2>3. Cookie analitici e di terze parti</H2>
        <P>
          La Piattaforma può avvalersi di servizi di terze parti (ad esempio mappe, servizi di hosting o invio
          notifiche) che potrebbero installare propri cookie. Qualora in futuro vengano introdotti cookie analitici o di
          profilazione non anonimizzati, questi saranno attivati solo previo consenso dell'utente tramite apposito
          banner, e la presente informativa sarà aggiornata di conseguenza.
        </P>

        <H2>4. Gestione e disattivazione dei cookie</H2>
        <P>
          L'utente può gestire, limitare o disabilitare i cookie direttamente dalle impostazioni del proprio browser. La
          disabilitazione dei cookie tecnici potrebbe compromettere il corretto funzionamento della Piattaforma, in
          particolare l'accesso all'area riservata.
        </P>

        <H2>5. Titolare del Trattamento</H2>
        <P>
          Il Titolare è <B>EAT ME S.r.l.</B>, P.IVA 02548710413, con sede legale in Via Palmiro Togliatti 21/2, 61122
          Pesaro (PU), PEC: <B>eatme@legalmail.it</B>. Per maggiori dettagli sul trattamento dei dati si rimanda alla
          Privacy Policy.
        </P>
      </>
    ),
  },
};

export const LEGAL_LINKS = [
  { slug: "termini", label: "Termini e Condizioni" },
  { slug: "privacy", label: "Privacy Policy" },
  { slug: "cookie", label: "Cookie Policy" },
];
